/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */
function init() {
 const actions = window.Shopify?.actions;if (!actions) return;
 actions.updateCart.configure({
 eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,});
 actions.openCart.configure({
 async handler() {
 /** @type {HTMLElement & {open?: () => void} | null} */
 const drawer = document.querySelector('theme-drawer#cart-drawer');
 if (drawer?.open) {
 drawer.open();} else {
 window.location.href = Theme.routes.cart_url || '/cart';}
 },});}
// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
 init();} else {
 document.addEventListener('DOMContentLoaded', init, { once: true });}
